import { useContext } from 'react';
import { StorefrontContext } from '../providers/StorefrontProvider';

const useStorefront = () => {
  return useContext(StorefrontContext);
};

export default useStorefront;
